var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddDoor = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "currentColor",
    viewBox: "0 0 80 80",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.909 12.632h-8.434V4.126C67.475 1.853 65.64 0 63.385 0h-.126a4.124 4.124 0 0 0-4.133 4.126v8.506h-8.392c-2.254 0-4.09 1.852-4.133 4.126v.126c0 2.316 1.837 4.169 4.133 4.169h8.392v8.463c0 2.274 1.837 4.168 4.133 4.126h.125c2.255 0 4.091-1.853 4.091-4.126v-8.463h8.434c2.254 0 4.091-1.853 4.091-4.127v-.168c0-2.274-1.837-4.126-4.091-4.126ZM36.907 13c2.03 0 3.69 1.675 3.69 3.722h1.16a9.042 9.042 0 0 0-.009.404c0 2.358.877 4.463 2.421 6.063.37.364.767.69 1.187.978h-4.759v52.11c0 2.048-1.66 3.723-3.69 3.723H3.69C1.66 80 0 78.325 0 76.278c0-2.047 1.66-3.722 3.69-3.722h3.691V16.722c0-2.047 1.661-3.722 3.691-3.722h25.835ZM25.835 46.5c0 2.047 1.66 3.722 3.69 3.722 2.03 0 3.69-1.675 3.69-3.722 0-2.047-1.66-3.722-3.69-3.722-2.03 0-3.69 1.675-3.69 3.722Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.67 25.632h2.602v4.252c0 3.334 1.961 6.224 4.779 7.571v35.1h3.69c2.03 0 3.69 1.676 3.69 3.723 0 2.047-1.66 3.722-3.69 3.722H55.36c-2.03 0-3.69-1.675-3.69-3.722V25.632Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddDoor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add_door.e92fd8d0ecc2d440f6b92d8ea1db5a26.svg";